function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import stripTags from 'striptags';
import ResourceRating from './ResourceRating';
import ResourcePrice from './ResourcePrice';
import DebugInfo from './DebugInfo';
import getCardClasses from '../util/GetCardClasses';
import propComboValidator from '../util/PropComboValidator';

var ResourceCardComponent = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ResourceCardComponent, _React$PureComponent);

  var _super = _createSuper(ResourceCardComponent);

  function ResourceCardComponent(props, context) {
    var _this;

    _classCallCheck(this, ResourceCardComponent);

    _this = _super.call(this, props, context);

    _defineProperty(_assertThisInitialized(_this), "state", {
      imageFailed: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleImageFail", function () {
      _this.setState({
        imageFailed: true
      });
    });

    return _this;
  }

  _createClass(ResourceCardComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          authorUsername = _this$props.authorUsername,
          authorId = _this$props.authorId,
          bundledSaleResourcesCount = _this$props.bundledSaleResourcesCount,
          cardSize = _this$props.cardSize,
          debugMode = _this$props.debugMode,
          description = _this$props.description,
          discountedPrice = _this$props.discountedPrice,
          formattedPrice = _this$props.formattedPrice,
          hasDiscount = _this$props.hasDiscount,
          isBundleSale = _this$props.isBundleSale,
          mzData = _this$props.mzData,
          price = _this$props.price,
          priceCents = _this$props.priceCents,
          ratingAverage = _this$props.ratingAverage,
          ratingCount = _this$props.ratingCount,
          resourceUrl = _this$props.resourceUrl,
          flags = _this$props.flags,
          thumbnailUrl = _this$props.thumbnailUrl,
          title = _this$props.title,
          isLazyLoaded = _this$props.isLazyLoaded,
          url = _this$props.url,
          bundleOriginalPrice = _this$props.bundleOriginalPrice,
          discountBestPercentage = _this$props.discountBestPercentage,
          formattedBundleOriginalPrice = _this$props.formattedBundleOriginalPrice,
          overrideContainingDiv = _this$props.overrideContainingDiv,
          showPrice = _this$props.showPrice,
          onQuickViewClick = _this$props.onQuickViewClick,
          showQuickView = _this$props.showQuickView,
          alwaysShowQuickView = _this$props.alwaysShowQuickView,
          advertisement = _this$props.advertisement;
      var localeMatch = (resourceUrl || url || '').match(/^\/([a-z]{2}-[a-z]{2}\/)?/);
      var localePrefix = localeMatch ? localeMatch[0].slice(0, -1) : '';
      var size = {
        sm: 2,
        lg: 4
      };
      var cardsPerRow = this.props.cardsPerRow || [2, 2, 3, 3, 3][size[cardSize]];
      var debugComponent = debugMode ? /*#__PURE__*/React.createElement(DebugInfo, this.props) : null;
      var prioFlag = !flags || flags.length === 0 ? null : flags.find(function (flag) {
        return flag.priority === Math.min.apply(Math, _toConsumableArray(flags.map(function (flag) {
          return flag.priority;
        })));
      });
      var bundleOrSale;

      if (hasDiscount) {
        if (isBundleSale) {
          bundleOrSale = 'Bundle Sale';
        } else {
          bundleOrSale = 'Sale';
        }
      } else if (isBundleSale) {
        bundleOrSale = 'Bundle';
      }

      var containingDivClasses = classNames({
        'col-sm-6': true,
        'col-sm-12': cardsPerRow === 1,
        'col-md-12 col-lg-6': cardsPerRow === 2,
        'col-lg-4': cardsPerRow === 3,
        'col-md-3': cardsPerRow === 4 && cardSize === 'lg',
        'mb-2': true
      });
      var avatarCdnUrl = 'https://d2w4qhtqw2dbsq.cloudfront.net';
      var authorComponent = /*#__PURE__*/React.createElement("figure", {
        className: "resource-card__avatar"
      }, /*#__PURE__*/React.createElement("a", {
        href: "".concat(localePrefix, "/teaching-resources/shop/").concat(authorUsername),
        "data-mz": true
      }, /*#__PURE__*/React.createElement("img", {
        className: "resource-card__avatar-image",
        src: "".concat(avatarCdnUrl, "/profile_live/").concat(authorId, "/small.jpg"),
        width: "30",
        height: "30",
        alt: authorUsername
      })), /*#__PURE__*/React.createElement("span", {
        className: "author"
      }, /*#__PURE__*/React.createElement("a", {
        className: "author__link",
        href: "".concat(localePrefix, "/teaching-resources/shop/").concat(authorUsername),
        "data-mz": true
      }, authorUsername)));
      var descriptionComponent = null;

      if (size[cardSize] === size.sm) {
        descriptionComponent = /*#__PURE__*/React.createElement("div", {
          className: classNames(getCardClasses('resource-card__media-description', cardSize))
        }, stripTags(description));
      }

      var priceComponent = /*#__PURE__*/React.createElement(ResourcePrice, {
        formattedPrice: formattedPrice,
        discountedPrice: discountedPrice,
        price: price,
        priceCents: priceCents,
        hasDiscount: hasDiscount,
        cardSize: cardSize,
        discountBestPercentage: discountBestPercentage,
        bundleOriginalPrice: bundleOriginalPrice,
        bundleOriginalForexPrice: bundleOriginalPrice,
        formattedBundleOriginalPrice: formattedBundleOriginalPrice,
        isBundleSale: isBundleSale,
        advertisement: advertisement
      });
      var priceListItem = /*#__PURE__*/React.createElement(ResourcePrice, {
        formattedPrice: formattedPrice,
        discountedPrice: discountedPrice,
        price: price,
        priceCents: priceCents,
        hasDiscount: hasDiscount,
        cardSize: cardSize,
        discountBestPercentage: discountBestPercentage,
        bundleOriginalPrice: bundleOriginalPrice,
        formattedBundleOriginalPrice: formattedBundleOriginalPrice,
        isBundleSale: isBundleSale,
        listClasses: classNames(getCardClasses('resource-card__media-footer__list', cardSize), {
          'resource-card__media-footer__list--aside': true,
          'resource-card__media-footer__list--paid': formattedPrice && price !== 0,
          'resource-card__media-footer__list--sale': hasDiscount
        })
      });
      var mediaFooterComponent = null;

      if (advertisement) {
        mediaFooterComponent = /*#__PURE__*/React.createElement("div", {
          className: "resource-card__meta resource-card__meta--ad"
        }, "Advertisement");
      } else {
        mediaFooterComponent = /*#__PURE__*/React.createElement("div", {
          className: "resource-card__meta"
        }, showPrice && priceListItem, isBundleSale ? /*#__PURE__*/React.createElement("span", {
          className: "resource-card__media-footer__text"
        }, bundledSaleResourcesCount, " Resources") : /*#__PURE__*/React.createElement(ResourceRating, {
          ratingCount: ratingCount,
          ratingAverage: ratingAverage,
          cardSize: cardSize
        }));
      }

      var flagComponent = null;

      if (prioFlag) {
        flagComponent = /*#__PURE__*/React.createElement("div", {
          className: "resource-card__recommended"
        }, /*#__PURE__*/React.createElement("span", {
          className: "resource-card__recommended-txt",
          style: {
            backgroundColor: prioFlag.color,
            color: prioFlag.textColor
          }
        }, prioFlag.badge ? prioFlag.badge.toUpperCase() : prioFlag.name.toUpperCase()));
      } else if (bundleOrSale) {
        flagComponent = /*#__PURE__*/React.createElement("div", {
          className: "resource-card__recommended"
        }, /*#__PURE__*/React.createElement("span", {
          className: "resource-card__recommended-txt",
          style: {
            backgroundColor: '#ff8200',
            color: '#fff'
          }
        }, bundleOrSale));
      }

      var mzProps = {
        'data-mz': ''
      };

      for (var mzDataKey in mzData) {
        if (mzData.hasOwnProperty(mzDataKey)) {
          mzProps["data-".concat(mzDataKey)] = mzData[mzDataKey];
        }
      }

      var imageComponent = null;

      if (!this.state.imageFailed) {
        var imageSrc = {
          src: thumbnailUrl
        };

        if (isLazyLoaded) {
          imageSrc.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
          imageSrc['data-echo'] = thumbnailUrl;
        }

        imageComponent = /*#__PURE__*/React.createElement("img", _extends({
          onError: this.handleImageFail,
          className: "resource-card__media-object",
          alt: title
        }, imageSrc, {
          loading: "lazy"
        }));
      }

      var quickViewComponent = /*#__PURE__*/React.createElement("span", {
        className: classNames({
          'js-quick-view-toggle': true,
          'resource-card__quick-view': !alwaysShowQuickView,
          'resource-card__quick-view--always-visible': alwaysShowQuickView
        }),
        onClick: onQuickViewClick
      }, "Quick View");
      var article = /*#__PURE__*/React.createElement("article", {
        className: classNames({
          'resource-card': true,
          'resource-card--bundle': isBundleSale
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames(getCardClasses('resource-card__container', cardSize), {
          'resource-card__container--recommended': prioFlag
        }, {
          'resource-card__container--bundle': isBundleSale
        })
      }, flagComponent, debugComponent, /*#__PURE__*/React.createElement("div", {
        className: cardSize === 'xl' ? '' : 'resource-card__quick-view-container'
      }, /*#__PURE__*/React.createElement("a", _extends({
        className: classNames(getCardClasses('resource-card__media-object-container', cardSize)),
        href: resourceUrl || url
      }, mzProps), imageComponent), showQuickView && quickViewComponent), /*#__PURE__*/React.createElement("div", {
        className: classNames(getCardClasses('resource-card__media-body', cardSize))
      }, !advertisement && authorComponent, /*#__PURE__*/React.createElement("h4", {
        className: classNames(getCardClasses('resource-card__media-heading', cardSize))
      }, /*#__PURE__*/React.createElement("a", _extends({
        className: "resource-card__media-heading-link",
        href: resourceUrl || url
      }, mzProps), title), cardSize === 'xxs' && showPrice && priceComponent), mediaFooterComponent, descriptionComponent)));
      if (overrideContainingDiv) return article;
      return /*#__PURE__*/React.createElement("div", {
        className: containingDivClasses
      }, article);
    }
  }]);

  return ResourceCardComponent;
}(React.PureComponent);

ResourceCardComponent.displayName = "ResourceCardComponent";
export { ResourceCardComponent as default };
ResourceCardComponent.propTypes = {
  /** Author Username */
  authorUsername: PropTypes.string.isRequired,

  /** Author avatar */
  authorId: PropTypes.string.isRequired,

  /** how many resources in a bundle, should be 0 for non-bundles */
  bundledSaleResourcesCount: PropTypes.number,

  /** Number of cards per row, factor of 12 */
  cardsPerRow: PropTypes.number,

  /** Size of card, xxs, xs, sm, md or lg */
  cardSize: PropTypes.string,

  /** Use debug mode and render a DebugInfo component */
  debugMode: PropTypes.bool,

  /** Resource Description */
  description: PropTypes.string.isRequired,

  /** Discounted Price (Ex: '0.75', '1.25') */
  discountedPrice: PropTypes.string,

  /** Formatted price (Ex: '$1.00', '$2.99') */
  formattedPrice: PropTypes.string,

  /** Does resource have discount */
  hasDiscount: PropTypes.bool,

  /** whether or not the resource is a bundle sale */
  isBundleSale: PropTypes.bool,

  /** MZ data */
  mzData: PropTypes.object,

  /** numerical price (Ex: '1', '2.99') */
  price: PropTypes.number,

  /** numerical price (Ex: '100', '299') */
  priceCents: PropTypes.number,

  /** From 0 to 5, represented by stars */
  ratingAverage: PropTypes.number.isRequired,

  /** Count of ratings received */
  ratingCount: PropTypes.number.isRequired,

  /** Resource Url */
  resourceUrl: PropTypes.string,

  /** flags for resource */
  flags: PropTypes.array,

  /** Image Url */
  thumbnailUrl: PropTypes.string.isRequired,

  /** Resource Title */
  title: PropTypes.string.isRequired,

  /** Whether to load imageComponent using echo lazy-loading */
  isLazyLoaded: PropTypes.bool,

  /** numerical price (Ex: '1', '2.99') */
  bundleOriginalPrice: PropTypes.number,

  /** numerical percentage (Ex: '0.2', '0.15') */
  discountBestPercentage: PropTypes.string,

  /** Formatted bundle original price (Ex: '$1.00', '$2.99') */
  formattedBundleOriginalPrice: PropTypes.string,

  /** Resource Url */
  url: propComboValidator(PropTypes.string, ['resourceUrl', 'url']),

  /** Prevents wrapping in containingDivClasses, resizing wrapping done externally */
  overrideContainingDiv: PropTypes.bool,
  showPrice: PropTypes.bool,
  onQuickViewClick: PropTypes.func,
  showQuickView: PropTypes.bool,
  alwaysShowQuickView: PropTypes.bool,

  /** Set true for app-marketing advertisement cards */
  advertisement: PropTypes.bool
};
ResourceCardComponent.defaultProps = {
  cardSize: 'lg',
  mzData: {},
  showPrice: true,
  advertisement: false
};